import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "xl:grid xl:grid-cols-[384px_auto_370px] flex lg:flex-wrap lg:flex-row flex-col items-start xl:h-[calc(100vh-154px)] overflow-hidden" }
const _hoisted_2 = { class: "xl:sticky lg:pl-6 lg:pr-0 pr-6 xl:top-6 xl:mt-0 mt-6 xl:my-7 shrink-0 lg:w-auto w-full" }
const _hoisted_3 = { class: "relative grid grid-cols-2 gap-3 p-6 border border-gray-200 rounded-2xl" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Patient Profile")
], -1)
const _hoisted_5 = { class: "col-span-1" }
const _hoisted_6 = { class: "mb-1 text-sm font-bold" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-medium text-neutral-500" }, "Firstname", -1)
const _hoisted_8 = { class: "col-span-1" }
const _hoisted_9 = { class: "mb-1 text-sm font-bold" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-medium text-neutral-500" }, "Lastname", -1)
const _hoisted_11 = { class: "col-span-1" }
const _hoisted_12 = { class: "mb-1 text-sm font-bold" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-medium text-neutral-500" }, "Sex Assigned at Birth", -1)
const _hoisted_14 = { class: "col-span-1" }
const _hoisted_15 = { class: "mb-1 text-sm font-bold" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-medium text-neutral-500" }, "Gender", -1)
const _hoisted_17 = { class: "col-span-1" }
const _hoisted_18 = { class: "mb-1 text-sm font-bold" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-medium text-neutral-500" }, "Date Registered Date", -1)
const _hoisted_20 = {
  key: 0,
  class: "col-span-2"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "View Profile", -1)
const _hoisted_22 = {
  key: 0,
  class: "flex flex-col h-full lg:px-6 lg:pt-6 lg:mt-0 mt-6 space-y-4 overflow-y-auto xl:w-auto lg:w-[calc(100%-334px)] w-full"
}
const _hoisted_23 = { class: "flex md:items-center md:justify-between md:flex-row flex-col md:space-y-0 space-y-3" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "block font-semibold" }, "Case History"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-normal text-gray-700" }, "Please select the Case Number to access the patient's details.")
], -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, "Add New Case", -1)
const _hoisted_26 = { class: "flex flex-col space-y-3 md:items-center md:justify-between md:flex-row md:space-y-0" }
const _hoisted_27 = { class: "relative md:min-w-[265px] w-auto" }
const _hoisted_28 = {
  type: "submit",
  class: "border-0 absolute top-0 left-0 z-[1] px-3 py-[14px] hover:bg-primary-600 rounded-l group transition",
  title: "Search cases"
}
const _hoisted_29 = { class: "self-end" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-medium text-neutral-600" }, "Showing:", -1)
const _hoisted_31 = { class: "text-xs font-semibold" }
const _hoisted_32 = { class: "space-y-5" }
const _hoisted_33 = { class: "w-full px-6 border-t py-7" }
const _hoisted_34 = {
  key: 1,
  class: "xl:w-[370px] xl:mt-0 mt-6 w-full h-full overflow-y-auto p-6 bg-gray-100"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4 font-bold" }, "Latest Interventions", -1)
const _hoisted_36 = { class: "grid grid-cols-1 gap-4 md:grid-cols-2" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", null, "Load more", -1)
const _hoisted_38 = {
  key: 1,
  class: "mb-4 text-xs text-center text-secondary-600"
}

import { ref, onMounted, watch, computed } from "vue";
import UserLayout from "@/layouts/UserLayout.vue";
import TextInput from "@/components/inputs/TextInput.vue";
import DatePicker from "@/components/inputs/DatePicker.vue";
import FilterPanel from "@/components/partials/FilterPanel.vue";
import CaseCard from "@/components/cards/CaseCard.vue";
import InterventionCard from "@/components/cards/InterventionCard.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import { PlusIcon } from "@heroicons/vue/24/outline";
import { useRouter, useRoute } from "vue-router";
import throttle from "lodash/throttle";
import pickBy from "lodash/pickBy";
import MinifyPagination from "@/components/partials/MinifyPagination.vue";
import { ViewPatientInterface } from "@/interfaces/PatientInterface";
import { CardCaseInterface, CardCaseIntervetionInterface, CardCaseFilterInterface } from "@/interfaces/Cases/Case";
import { hasPermission } from "@/classes/AuthService";
import PageLoader from "@/components/loaders/PageLoader.vue";
import { useNetworkStore } from "@/store/network";
import { onIonViewWillEnter } from "@ionic/vue";
import SearchTwoIcon from "@/components/icons/searchTwoIcon.vue";
import InterventionService from "@/classes/Interventions/InterventionService";
import CaseHistoryOfflineService from "@/classes/Cases/CaseHistory/Offline/OfflineService";
import CaseHistoryService from "@/classes/Cases/CaseHistory/CaseHistoryService";
import OnlineSynching from "@/classes/Synching/OnlineSynching";


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewPage',
  setup(__props) {

const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);

const router = useRouter();
const route = useRoute();
const showFilter = ref<boolean>(false);
const loadingIntervention = ref<boolean>(false);
const patientInfo = ref<ViewPatientInterface>({});
const patientCases = ref<CardCaseInterface[]>([]);
const filterSearch = ref<string | null>(route.query.query);
const filterDate = ref<string | null>(route.query.date);
const filterInitiatedAt = ref<string | null>(route.query.initiated_at);
const page = ref<string | null>(route.query.page);
const lastPage = ref<string | null>(null);
const rows = ref<number | null>(route.query.rows || 5);
const numRows = computed<string | null>(() => (rows.value ? rows.value + " Rows" : "All"));
const patientId = ref<number>(route.params.patient);
const loading = ref<boolean>(false);
const onlineSync = new OnlineSynching();

const filters = computed<CardCaseFilterInterface>(() => {
	return {
		query: filterSearch.value,
		page: page.value,
		rows: rows.value,
		initiated_at: filterInitiatedAt.value,
		date: filterDate.value,
		interventionPage: 1
	};
});

const patientInterventions = ref < {
	data: CardCaseIntervetionInterface[]
	page: number,
	last_page: number,
} > ({
	data: [],
	page: filters.value.interventionPage,
	last_page: 0,
});

const getData = async (search: any = null, setLoading = true): void => {
	loading.value = setLoading;
	if (search) {
		filterSearch.value = search;
	}
    
    // Call this service when network is online or offline
    const response = await CaseHistoryService.index(
        patientId.value,
        pickBy({ ...filters.value }),
        isNetworkAvailable.value
    );

    if (response?.response?.status === 404) {
        loading.value = false;
        return;
    }
    
    if (response?.status === 200 || response?.data != undefined) {
        const data = response.data;

		patientInfo.value = data.item;
		patientCases.value = data.cases;
		page.value = data.cases.current_page;
		lastPage.value = data.cases.last_page;

        // If network is available sync data to offline
        if (isNetworkAvailable.value) {
            await CaseHistoryOfflineService.syncToOffline(data);
        }

		await getInterventions();
        loading.value = false;
    } else {
        const error = response;
        loading.value = false;
        console.log(error);
    }
};

const reloadPage = async () => {
	return await router.push({
		path: `/patient/${patientId.value}/view`,
		query: pickBy(filters.value),
	});
};

const applyFilters = async (search: any = null, setLoading = true) => {
    await reloadPage();
    await getData(search, setLoading);
    showFilter.value = false;
};

const applyReset = async () => {
	filterDate.value = "";
	filterInitiatedAt.value = "";
    await reloadPage();
    await getData();
    showFilter.value = false;
};


const loadMoreIntervention = async () => {
	filters.value.interventionPage += 1;
	loadingIntervention.value = true;

	await getInterventions();
};


const getInterventions = async ():Promise<void> => {
	loading.value = true;
    await CaseHistoryService.latestInterventions(patientId.value, null, { page: filters.value.interventionPage }, isNetworkAvailable.value)
		.then(({data}) => {
			setInterventions(data.items);
		})
		.catch(errors => console.error(errors))
		.finally( () =>loading.value = false)
}

const setInterventions = (latestInterventions:any) => {
	loadingIntervention.value = false;

	if (patientInterventions.value.data.length == 0) {
		patientInterventions.value.data = latestInterventions.data;
	} else if (latestInterventions.to !== latestInterventions.total) {
		patientInterventions.value.data.push(...latestInterventions.data);
	}

	if(patientInterventions.value.data.length > 0 && isNetworkAvailable.value) {
		InterventionService.storeOffline(latestInterventions.data)
	}

	patientInterventions.value.last_page =  latestInterventions.last_page
	patientInterventions.value.page =  latestInterventions.current_page

}

const changeRows = async (row: any): void => {
	rows.value = row;
	await applyFilters();
};

const paginate = async (data: number): void => {
	page.value = data;
	await applyFilters();
};

/**
 * WATCHERS
 */
watch(
	filterSearch,
	throttle(async (val: string) => {
		await applyFilters(val, false);
	}, 1000)
);

watch(
    () => isNetworkAvailable.value,
    async () => {
        loading.value = false;
        await getData();
        await onlineSync.checkDrafts();
    }
)


onIonViewWillEnter(async () => {
    await getData();
    await onlineSync.checkDrafts();
}); 

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, {
    hasBack: "",
    backLink: "/patient/index",
    backTitle: "View Patient Summary",
    mainCustomClass: "resetView !min-h-0 !mx-0"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(patientInfo.value.first_name), 1),
              _hoisted_7
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", _hoisted_9, _toDisplayString(patientInfo.value.last_name), 1),
              _hoisted_10
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("p", _hoisted_12, _toDisplayString(patientInfo.value.sex_at_birth_meta?.description), 1),
              _hoisted_13
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("p", _hoisted_15, _toDisplayString(patientInfo.value.gender_meta?.description), 1),
              _hoisted_16
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("p", _hoisted_18, _toDisplayString(patientInfo.value.registered_at_formatted), 1),
              _hoisted_19
            ]),
            (_unref(hasPermission)('can-update-patient-information'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("a", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (
								_unref(router).replace(
									`/patient/profile/${patientId.value}/edit`
								)
							))
                  }, [
                    _createVNode(ButtonComponent, {
                      customClass: "quaternary w-full",
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_21
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_unref(hasPermission)('can-view-patients-incident-history'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                (_unref(hasPermission)('can-create-patient-incident'))
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (
							_unref(router).replace(`/patient/${patientId.value}/case/create`)
						))
                    }, [
                      _createVNode(ButtonComponent, { size: "large" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(PlusIcon), { class: "w-4 h-4 text-primary-600 stroke-[3px] -ml-2 mr-1 icon" }),
                          _hoisted_25
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("button", _hoisted_28, [
                    _createVNode(SearchTwoIcon, { class: "w-5 h-5 object-contain grayscale brightness-[0.3] group-hover:invert group-hover:brightness-0 transition" })
                  ]),
                  _createVNode(TextInput, {
                    type: "text",
                    placeholder: "Search Cases",
                    name: "search_cases",
                    id: "search_cases",
                    customClass: "!pl-12 frm-input search",
                    modelValue: filterSearch.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filterSearch).value = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "border-neutral-100 hover:bg-primary-100 transition border-solid border rounded px-3 py-[15px] flex space-x-1 items-center w-max",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (showFilter.value = true))
                  }, [
                    _hoisted_30,
                    _createElementVNode("span", _hoisted_31, "All Records (" + _toDisplayString(patientCases.value.total) + ")", 1)
                  ]),
                  _createVNode(FilterPanel, {
                    show: showFilter.value,
                    onClose: _cache[6] || (_cache[6] = ($event: any) => (showFilter.value = false)),
                    "onApply:reset": _cache[7] || (_cache[7] = ($event: any) => (applyReset())),
                    "onApply:filters": _cache[8] || (_cache[8] = ($event: any) => (applyFilters()))
                  }, {
                    fields: _withCtx(() => [
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(DatePicker, {
                          id: "date_initiated",
                          name: "date_initiated",
                          label: "Date Initiated",
                          range: true,
                          modelValue: filterInitiatedAt.value,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filterInitiatedAt).value = $event))
                        }, null, 8, ["modelValue"]),
                        _createVNode(DatePicker, {
                          id: "date_created",
                          name: "date_created",
                          label: "Date Created",
                          modelValue: filterDate.value,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filterDate).value = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["show"])
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(patientCases.value.data, (item) => {
                return (_openBlock(), _createBlock(CaseCard, {
                  key: item,
                  routeLink: `/patient/${patientId.value}/cases/${item.id}/edit`,
                  routeDeleteLink: `/patients/${patientId.value}/cases/${item.id}/delete`,
                  date: item.initiated_at_formatted,
                  caseNumber: item.case_number,
                  primaryDiagnosis: item?.diagnoses?.primary_diagnoses?.name,
                  comorbidList: item.comorbidities?.map((item) => item.name),
                  perpetratorList: item.perpetrators?.map((item) => item.name)
                }, null, 8, ["routeLink", "routeDeleteLink", "date", "caseNumber", "primaryDiagnosis", "comorbidList", "perpetratorList"]))
              }), 128)),
              _createElementVNode("div", _hoisted_33, [
                _createVNode(MinifyPagination, {
                  numRows: numRows.value,
                  "onUpdate:rows": _cache[9] || (_cache[9] = (value) => changeRows(value)),
                  "onUpdate:page": _cache[10] || (_cache[10] = (value) => paginate(value)),
                  "current-page": page.value,
                  "last-page": lastPage.value
                }, null, 8, ["numRows", "current-page", "last-page"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(hasPermission)('can-view-intervations'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _hoisted_35,
              _createElementVNode("div", _hoisted_36, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(patientInterventions.value.data, (item) => {
                  return (_openBlock(), _createBlock(InterventionCard, {
                    key: item,
                    typeTwo: "",
                    item: item,
                    status: item.status,
                    interventionType: item.intervention_type_name,
                    intervention: item.type,
                    caseNumber: item.case_number,
                    doneBy: item.done_by,
                    doneOn: item.done_on,
                    class: "col-span-1 xl:col-span-2"
                  }, null, 8, ["item", "status", "interventionType", "intervention", "caseNumber", "doneBy", "doneOn"]))
                }), 128))
              ]),
              (!loadingIntervention.value && patientInterventions.value.last_page != patientInterventions.value.page)
                ? (_openBlock(), _createBlock(ButtonComponent, {
                    key: 0,
                    class: "w-auto mx-auto my-4 xl:w-full xl:mx-0",
                    size: "large",
                    onClick: loadMoreIntervention
                  }, {
                    default: _withCtx(() => [
                      _hoisted_37
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (loadingIntervention.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_38, " Loading more... "))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})